import { getActKC2StatusColor, getActKC2StatusLabel } from 'pages/Project/Common/types';
import { Button, IconArrowDown, IconArrowRight, Badge } from 'uikit';
import { formatDateToLocale, formatNumberToRu } from 'utils';

import type { ICellRendererParams } from 'ag-grid-community';
import type React from 'react';

import type { ActListItemWithGroupInfo, ColumnsCommonProps } from '../types';

interface TNumberColumnRenderer extends ICellRendererParams<ActListItemWithGroupInfo>, ColumnsCommonProps {}

const getName = (number: string | undefined | null): string => {
    if (!number) {
        return '';
    }
    const actNameStartsWithNumber = number?.toString()?.startsWith('№');

    if (actNameStartsWithNumber) {
        return number;
    }

    return `№${number}`;
};

export const NumberColumnRenderer = (props: TNumberColumnRenderer) => {
    const { data, collapseState, changeCollapseState } = props;

    if (data?.isGroup) {
        const currentGroupId = data?.groupKey;

        const areChildrenShown = !(currentGroupId && collapseState?.[currentGroupId]);

        return (
            <div style={{ marginLeft: data?.level ? '28px' : undefined }}>
                {!!data?.childGroups?.length && (
                    <Button
                        size="xs"
                        view="clear"
                        onlyIcon
                        iconRight={areChildrenShown ? IconArrowDown : IconArrowRight}
                        onClick={data?.childGroups ? changeCollapseState?.(data?.childGroups) : undefined}
                        style={{ marginRight: '10px' }}
                    />
                )}
                {!data?.level ? data?.number : `КС-3 ${getName(data?.actKC3FullNumber)}`}
            </div>
        );
    }

    const { actKC2Status } = data ?? {};

    return (
        <div style={{ marginLeft: '84px', display: 'flex', alignItems: 'center' }}>
            <Badge
                minified
                size="s"
                style={{ marginRight: 5 }}
                label={getActKC2StatusLabel(actKC2Status)}
                status={actKC2Status ? getActKC2StatusColor(actKC2Status) : undefined}
                className={
                    actKC2Status && getActKC2StatusColor(actKC2Status) === 'progress'
                        ? 'BadgeColor_progress'
                        : undefined
                }
            />
            Акт КС-2 {getName(data?.actKC2FullNumber)}
        </div>
    );
};

export const ActKc2OrKc3Field = (
    props: TNumberColumnRenderer & {
        kc2Field: keyof ActListItemWithGroupInfo;
        kc3Field: keyof ActListItemWithGroupInfo;
        costRounding?: number;
        isDate?: boolean;
    },
) => {
    const { data, kc2Field, kc3Field, isDate, costRounding } = props;

    if (data?.isGroup) {
        if (!kc3Field) {
            return '';
        }

        return (
            (isDate ? formatDateToLocale(data[kc3Field]) : formatNumberToRu(data[kc3Field], costRounding ?? 2)) || ''
        );
    }

    if (!kc2Field) {
        return '';
    }

    return (
        (isDate ? formatDateToLocale(data?.[kc2Field] ?? '') : formatNumberToRu(data?.[kc2Field], costRounding ?? 2)) ||
        ''
    );
};

NumberColumnRenderer.displayName = 'NumberColumnRenderer';
